import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import login from '@/login/login'
import carSeve from '@/components/carSeve'
import Details from '@/components/shopDetail'
import topUp from '@/components/topUpDetail'
import fixedCode from '@/components/fixedCode'
import shopRechar from '@/components/recharte'
import fixedList from '@/components/fixedList'
import danymicCode from '@/components/danymicCode'
import danCode from '@/components/danCode'
import { util } from '../utils/global'

Vue.use(Router)

const router = new Router({
  base:"/history",
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/index',
      name: 'index',
      component: index,
      redirect:'/carSeve',
      children:[
        {
          path: '/carSeve',
          name: 'carSeve',
          component: carSeve
        },
        {
          path:'/shopDetail',
          name:'shopDetail',
          component:Details
        },
        {
          path:'/topUpDetail',
          name:'topUpDetail',
          component:topUp
        },
        {
          path:'/fixedCode',
          name:'fixedCode',
          component:fixedCode
        },
        {
          path:'/danymicCode',
          name:'danymicCode',
          component:danymicCode
        },
        {
          path:'/danCode',
          name:'danCode',
          component:danCode
        },
        {
          path:'/shopRechar',
          name:'shopRechar',
          component:shopRechar
        },
        {
          path:'/fixedList',
          name:'fixedList',
          component:fixedList
        }
      ]
    },
    
  ]
})

//路由导航守卫
router.beforeEach((to, from, next) => {
  // to 要去的路由配置
  // from 当前的路由配置
  // next 一定要调用，让to的路由配置继续生效，比如如果去登陆直接next(),否则判断token是否存在，如果存在就next()
  if (to.path === '/login') return next() ;//使用return，不需要写else
  //判断其他页面是否有token
  const cpfuserInfo = sessionStorage.getItem('shopData');
  // 存在继续往后走
  if (cpfuserInfo) return next();
  // this.$router.push({name:'login'}) #没有this,无法使用
  router.push({
    name: 'login'
  })
});

export default router


// WEBPACK FOOTER //
// ./src/router/index.js